module.exports = __webpack_public_path__ + "static/img/050401.74e6294b.png";